module.exports = __webpack_public_path__ + "img/gt.170b3a11.svg";